import { RowCrudStatus } from "../../common/types";
import { SignedEditionBlockchainCert } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type SignedEditionBlockchainCertValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  contractNumber: string;
  file: string;
  file_data: FileCRUDType;
  __file_files: FileCRUDType[];
  confirmedAt: Date | null;
};

export type SignedEditionBlockchainCertErrorsType = {
  name?: { message: string; fieldLabel: string };
  contractNumber?: { message: string; fieldLabel: string };
  file?: { message: string; fieldLabel: string };
  confirmedAt?: { message: string; fieldLabel: string };
};

export function SignedEditionBlockchainCertValuesInit(): SignedEditionBlockchainCertValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    contractNumber: "",
    file: "",
    file_data: fileCRUDInit(),
    __file_files: [],
    confirmedAt: null,
  };
}

export type SignedEditionBlockchainCertType =
  | SignedEditionBlockchainCert
  | SignedEditionBlockchainCertValuesType;

export function signedEditionBlockchainCertDisplayId(
  source: Partial<SignedEditionBlockchainCert>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getSignedEditionBlockchainCertValues(
  source: SignedEditionBlockchainCertType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SignedEditionBlockchainCertValuesType {
  const entityValues = SignedEditionBlockchainCertValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : signedEditionBlockchainCertDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.contractNumber = source.contractNumber;
  entityValues.__file_files =
    source.file_data && !_duplicated
      ? [
          {
            id:
              "id" in source.file_data && source.file_data.id
                ? source.file_data.id
                : `generated_${uniqueCounter++}`,
            name: source.file_data.name,
            description: source.file_data.description || undefined,
            size: source.file_data.size || 0,
            formattedSize: source.file_data.size
              ? formatBytes(source.file_data.size)
              : "",
            mimetype: source.file_data.mimetype,
            url: source.file_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.file = source.file && !_duplicated ? source.file : "";
  entityValues.file_data =
    source.file_data && "__status__" in source.file_data
      ? source.file_data
      : source.file_data
      ? {
          id: ("id" in source.file_data && source.file_data.id
            ? source.file_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.file_data.name,
          description: source.file_data.description || undefined,
          size: source.file_data.size || 0,
          formattedSize: source.file_data.size
            ? formatBytes(source.file_data.size)
            : "",
          mimetype: source.file_data.mimetype,
          url: source.file_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  entityValues.confirmedAt = new Date(source.confirmedAt);
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
